// extracted by mini-css-extract-plugin
export default {"subtitleHighlight":"Educators_subtitleHighlight__99uhe","article":"Educators_article__D5cFw","contactInfo":"Educators_contactInfo__I1bIt","articles":"Educators_articles__RVVpo"};